export default "__VITE_ASSET__r4NB2YsG__"